// public record UserPropertyDetailsPerformanceCountDto(
// 		Integer totalProspectCount,
// 		Integer viewCount,
// 		boolean isStartDateStartOfTheMonth){
// }
const Performance = ({ totalProspectCount = 0, viewCount = 0, isStartDateStartOfTheMonth = false }) => ({
  totalProspectCount: Number(totalProspectCount),
  viewCount: Number(viewCount),
  isStartDateStartOfTheMonth: Boolean(isStartDateStartOfTheMonth),
});

export default Performance;

export type PerformanceProps = ReturnType<typeof Performance>;
